<div class="flex gap-4">
	<p
		*ngIf="allowCancel"
		class="hover:underline cursor-pointer"
		(click)="cancel()"
		[testHook]="testHooks.CancelParagraph"
	>
		Cancel order
	</p>

	<div
		class="text-green underline cursor-pointer"
		(click)="getQuote()"
		[testHook]="testHooks.GetQuoteDiv"
	>
		<ng-container *ngIf="quote$ | async as quote; else noQuote">
			<p>Get another quote</p>
		</ng-container>
	</div>

	<ng-template #noQuote>
		<p>Get quote</p>
	</ng-template>
</div>
